import React from "react";

const highlights = [
  { icon: "🏗️", title: "Angular migration", desc: "v18 → v21 on a government-scale app" },
  { icon: "🗄️", title: "PostgreSQL functions", desc: "Multi-path drill reporting at facility level" },
  { icon: "⚡", title: "Performance", desc: "Lazy loading, bundle optimisation, tree-shaking" },
  { icon: "🎨", title: "Creative coding", desc: "Three.js & WebGL interactive experiences" },
];

const timeline = [
  {
    year: "2023 – Present",
    role: "Full-Stack Developer",
    place: "Disaster Management Cell (Gov. Project)",
    desc: "Building dm-ui — Angular + PostgreSQL platform covering fire safety, facility reporting, and public health drill management.",
  },
  {
    year: "2022 – 2023",
    role: "MERN Stack Developer",
    place: "Freelance / Self Projects",
    desc: "Built blog platform, expense manager, COVID-19 tracker, and TodoMeet using React, Node.js, MongoDB.",
  },
  {
    year: "2019 – 2022",
    role: "B.Tech — Computer Science",
    place: "India",
    desc: "Core CS fundamentals, algorithms, web technologies.",
  },
];

const About = () => {
  return (
    <section id="about" style={{ background: "var(--bg2)", padding: "6rem 5%" }}>
      <div className="section-inner">
        <p className="section-label">About me</p>
        <h2 className="section-title">Who I am</h2>
        <div className="about-grid">
          <div className="about-text">
            <p>
              I'm a full-stack developer based in India, specialising in Angular-based web
              applications and PostgreSQL database engineering. My day-to-day involves
              building complex, data-driven systems that run at scale in government and
              healthcare infrastructure.
            </p>
            <p>
              I've led a major Angular migration (v18 → v21) on a government disaster
              management platform, designed multi-path PostgreSQL reporting functions, and
              built interactive MERN-stack side projects. I like clean architecture,
              automated tooling, and shipping things that actually work.
            </p>
            <div className="about-highlights">
              {highlights.map((h) => (
                <div key={h.title} className="highlight-card">
                  <div className="highlight-icon">{h.icon}</div>
                  <div className="highlight-title">{h.title}</div>
                  <div className="highlight-desc">{h.desc}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="timeline">
            {timeline.map((t) => (
              <div key={t.year} className="tl-item">
                <div className="tl-year">{t.year}</div>
                <div className="tl-role">{t.role}</div>
                <div className="tl-place">{t.place}</div>
                <div className="tl-desc">{t.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
